import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

import { ifAuthenticated, ifNotAuthenticated } from "./access";
import AuthLayout from "@/pages/AuthLayout.vue";
import Login from "@/pages/Login.vue";
import ChangePassword from "@/pages/ChangePassword.vue";

import profileMenu from "@/routes/profile";
import financesMenu from "@/routes/finances";
import accountsMenu from "@/routes/accounts";
import addressBookMenu from "@/routes/address_book";
import blackListMenu from "@/routes/black_list";
import distributionMenu from "@/routes/distribution";
import templateMenu from "@/routes/template";
import reportMenu from "@/routes/report";

import {AccessDenied} from "wings-ui-components";
import {ActionLog} from "@/store/auth/types";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    beforeEnter: ifAuthenticated,
    redirect: "/dashboard",
    name: "Home"
  },
  {
    path: "/",
    component: AuthLayout,
    name: "Authentication",
    beforeEnter: ifNotAuthenticated,
    children: [
      {
        path: "/login",
        name: "Login",
        component: Login
      }
    ]
  },
  {
    path: "/",
    component: AuthLayout,
    name: "ChangePasswordLayout",
    // beforeEnter: ifAuthenticated,
    children: [
      {
        path: "/change_password",
        name: "ChangePassword",
        component: ChangePassword
      }
    ]
  },
  profileMenu,
  financesMenu,
  accountsMenu,
  distributionMenu,
  templateMenu,
  addressBookMenu,
  blackListMenu,
  reportMenu,
  {
    name: "AccessDenied",
    path: "/access_denied",
    component: AccessDenied,
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: "history",
  routes,
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "nav-item active"
});

router.beforeEach((to, from, next) => {
  const localStorageUserToken = localStorage.getItem("lk-user-token");

  const actionLog: ActionLog = {
    actionPage: to.meta.msgKey,
    action: 'Viewing',
    actionStatus: 'success',
    objectType: 'Page',
  }

  // localStorageUserToken - проверяет активен ли токен чтобы избежать логировать страницу входа
  // !to.meta.parentPath - условия чтобы не логировать child страницы (/:id, /new)
  // !from.meta.parentPath - условия чтобы не логировать переход от child к parent (пока не нашел лучшее решение)

  if (Boolean(localStorageUserToken) && !to.meta.parentPath && !from.meta.parentPath && !!from.name) {
    store.dispatch('actionLog', actionLog).catch(e => console.error(e));
  }
  next();
});

export default router;
